"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const native_1 = require("@react-navigation/native");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const services_1 = require("services");
const context_1 = require("components/context");
const NewQuote_1 = require("components/partial/NewQuote");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const carrito_1 = require("services/carrito");
const OrdersPartial_1 = require("./orders/OrdersPartial");
exports.name = "AddProductsName";
const AddProducts = props => {
    const { route } = props;
    const { cliidForCatalog, cliid, warehouseCode, docEntry, lineId } = route?.params || {};
    const authContext = React.useContext(context_1.AuthContext);
    const [query, setQuery] = React.useState("");
    const onQueryChange = (query) => setQuery(query);
    const flatListRef = React.useRef();
    const shoppingCartIdentity = React.useRef("texto-cualquiera");
    const [initialLoading, setInitialLoading] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const currentPage = React.useRef(1);
    const lastPage = React.useRef(0);
    const blockRequest = React.useRef(false);
    const [products, setProducts] = React.useState(undefined);
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        setProducts(undefined);
        const onLoading = (loading) => setInitialLoading(loading);
        //normal
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            currentPage.current = 1;
            setProducts(response?.data);
        };
        const onFailSessionExpired = authContext?.signOut;
        if (docEntry == null) {
            (0, services_1.doQuoteCatalog)({
                params: {
                    data: {
                        q: query,
                        almacen: warehouseCode ?? "",
                        uid: cliidForCatalog ?? "",
                        page: "1",
                    },
                },
                callback: {
                    onSuccess,
                    onFailSessionExpired,
                    onLoading,
                },
            });
        }
        //new rv
        const onSuccessRV = (response) => {
            lastPage.current = response.pages ?? 0;
            setProducts(response?.data);
        };
        if (docEntry) {
            (0, services_1.doQuoteCatalogRV)({
                params: {
                    data: {
                        q: query,
                        docEntry: docEntry,
                        lineId: lineId,
                        page: "1",
                    },
                },
                callback: {
                    onSuccess: onSuccessRV,
                    onLoading,
                },
            });
        }
    }, [query, cliidForCatalog, warehouseCode, docEntry, lineId]));
    const loadMoreProducts = () => {
        let nextPage = currentPage.current + 1;
        const onFailSessionExpired = authContext?.signOut;
        //normal
        const onSuccess = (response) => {
            lastPage.current = response.pages ?? 0;
            if (response?.data?.length ?? 0 > 0) {
                setProducts(products => [...(products ?? []), ...(response?.data ?? [])]);
                setLoading(false);
                currentPage.current = nextPage;
            }
            blockRequest.current = false;
        };
        const onFail = (error) => {
            blockRequest.current = false;
        };
        if (docEntry == null) {
            (0, services_1.doQuoteCatalog)({
                params: {
                    data: {
                        q: query,
                        almacen: warehouseCode ?? "",
                        uid: cliidForCatalog ?? "",
                        page: nextPage.toString(),
                    },
                },
                callback: {
                    onSuccess: onSuccess,
                    onFail: onFail,
                    onLoading: setLoading,
                    onFailSessionExpired,
                },
            });
        }
        //new
        const onSuccessRV = (response) => {
            lastPage.current = response.pages ?? 0;
            if (response?.data?.length ?? 0 > 0) {
                setProducts(products => [...(products ?? []), ...(response?.data ?? [])]);
                setLoading(false);
                currentPage.current = nextPage;
            }
            blockRequest.current = false;
        };
        const onFailRV = (error) => {
            blockRequest.current = false;
        };
        if (docEntry) {
            (0, services_1.doQuoteCatalogRV)({
                params: {
                    data: {
                        q: query,
                        docEntry: docEntry ?? "",
                        lineId: lineId ?? "",
                        page: nextPage.toString(),
                    },
                },
                callback: {
                    onSuccess: onSuccessRV,
                    onFail: onFailRV,
                    onLoading: setLoading,
                    onFailSessionExpired,
                },
            });
        }
    };
    const [shoppingCartResponse, setShoppingCartResponse] = React.useState(null);
    const listShoppingCart = async () => {
        const onSuccess = (response) => {
            setShoppingCartResponse(response);
        };
        (0, services_1.doCarritoCotiList)({
            params: {
                clientId: cliid ?? "",
                almacen: docEntry ? `${docEntry ?? ""}-${lineId ?? ""}` : warehouseCode,
                tipo: docEntry ? "cotirvmt" : "coti",
            },
            callback: {
                onSuccess,
            },
        });
    };
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        listShoppingCart();
    }, [cliid, warehouseCode, docEntry, lineId]));
    //clear screen
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        return () => {
            setQuery("");
            setProducts(undefined);
            setShoppingCartResponse(undefined);
        };
    }, []));
    const addProduct = React.useCallback((product, size) => {
        const onSuccess = (response) => {
            listShoppingCart();
        };
        (0, services_1.doCarritoCotiAdd)({
            params: {
                clientId: cliid,
                almacen: docEntry ? `${docEntry ?? ""}-${lineId ?? ""}` : warehouseCode,
                tipo: docEntry ? "cotirvmt" : "coti",
                data: {
                    procodigo: product.codigo,
                    cantidad: size,
                    stockAlert: product.stockAlert,
                    stockAlertFecha: product.stockAlertFecha,
                    stockAlertReason: product.stockAlertReason,
                    stockAlertReasonType: product.stockAlertReasonType,
                    stockAlertColor: product.stockAlertColor,
                },
            },
            callback: {
                onSuccess: onSuccess,
            },
        });
    }, [cliid, warehouseCode]);
    const removeProduct = React.useCallback((product) => {
        const onSuccess = (response) => {
            listShoppingCart();
        };
        (0, services_1.doCarritoCotiRemove)({
            params: {
                clientId: cliid,
                almacen: docEntry ? `${docEntry ?? ""}-${lineId ?? ""}` : warehouseCode,
                tipo: docEntry ? "cotirvmt" : "coti",
                data: {
                    procodigo: product?.codigo,
                },
            },
            callback: {
                onSuccess: onSuccess,
            },
        });
    }, [cliid, warehouseCode]);
    const renderItem = ({ item }) => (<Product product={item} addProduct={addProduct} removeProduct={removeProduct}/>);
    const numColumns = (0, native_base_1.useBreakpointValue)({
        base: 1,
        xl: 2,
    });
    return (<>
			<native_base_1.View w="100%" h="100%" flexDirection={"column"} alignItems="strech">
				<Header onQueryChange={onQueryChange} onShoppingCartCleared={() => {
            const clearedSizeProducts = products;
            clearedSizeProducts?.forEach(element => (element.carrito = ""));
            setProducts(clearedSizeProducts);
            shoppingCartIdentity.current = (Math.random() + 1).toString(36).substring(7);
            listShoppingCart();
        }} shoppingCartResponse={shoppingCartResponse} docEntry={docEntry} {...props}/>
				<native_base_1.View borderRadius={theme_1.Sizes.configRadius} marginTop="30" flex="1" pb={10}>
					<native_base_1.FlatList ref={flatListRef} key={`${numColumns}${query}${shoppingCartIdentity.current}`} data={products} renderItem={renderItem} numColumns={numColumns} ListFooterComponent={() => (<native_base_1.View style={{ marginBottom: 300 }}>{isLoading && <native_base_1.Spinner size="lg" color="black"/>}</native_base_1.View>)} onScroll={e => {
            let paddingToBottom = 3000;
            paddingToBottom += e.nativeEvent.layoutMeasurement.height;
            var currentOffset = e.nativeEvent.contentOffset.y;
            var direction = currentOffset > 99999999999999999 ? "down" : "up"; //this?.offset ? "down" : "up";
            if (direction === "up") {
                if (e.nativeEvent.contentOffset.y >=
                    e.nativeEvent.contentSize.height - paddingToBottom) {
                    if (!isLoading && currentPage.current < lastPage.current && !blockRequest.current) {
                        blockRequest.current = true;
                        setTimeout(() => {
                            loadMoreProducts();
                        }, 10);
                    }
                }
            }
        }} px="16" flex={1}/>
				</native_base_1.View>
			</native_base_1.View>
			<FullScreenLoad_1.default isVisible={initialLoading}/>
		</>);
};
const ButtonAddProducts = () => {
    const navigation = (0, native_1.useNavigation)();
    return (<native_base_1.Button onPress={() => {
            navigation.goBack();
        }} w={{
            base: "90%",
            md: "auto",
        }} size="md" mx={{
            base: "auto",
            md: "20",
        }} mb={{
            base: 20,
            md: "",
        }}>
			{`${theme_1.Str.addProducts} +`}
		</native_base_1.Button>);
};
const Header = props => {
    const { onQueryChange, onShoppingCartCleared, shoppingCartResponse, docEntry } = props;
    const navigation = (0, native_1.useNavigation)();
    const onClearShoppingCartPress = () => {
        const onSuccess = () => {
            onShoppingCartCleared();
        };
        (0, carrito_1.doCarritoCotiClear)({
            params: {
                tipo: docEntry ? "cotirvmt" : "coti",
            },
            callback: {
                onSuccess: onSuccess,
            },
        });
    };
    const onShoppingCartPress = () => {
        navigation?.jumpTo(NewQuote_1.name, {});
    };
    return (<native_base_1.Stack w="100%" direction={{
            base: "column",
            md: "row",
        }} alignItems={{
            base: "flex-end",
            md: "center",
        }} justifyContent={{
            base: "strech",
            md: "space-between",
        }} mt="20" px={{
            base: 20,
            md: 20,
        }}>
			<SearchProduct onQueryChange={onQueryChange} w={{
            base: "100%",
            md: "auto",
        }} flex={{
            base: "",
            md: 1,
        }}/>

			<OrdersPartial_1.ShoppingCartIndicator onShoppingCartClick={onShoppingCartPress} shoppingCartSize={(shoppingCartResponse?.data?.length ?? 0).toString()} onClearShoppingCartPress={onClearShoppingCartPress} ml={20}/>
		</native_base_1.Stack>);
};
const SearchProduct = props => {
    const { onQueryChange, ...rest } = props;
    const [query, setQuery] = React.useState("");
    const handleChange = (event) => {
        onQueryChange(event.target.value);
        setQuery(event.target.value);
    };
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        return () => {
            setQuery("");
        };
    }, []));
    return (<native_base_1.Input placeholder={theme_1.Str.searchProduct} px="10" borderColor="white" borderRadius="40" value={query} onChange={handleChange} InputRightElement={<native_base_1.Image source={require("images/ic_search.svg")} variant="iconInputRight" alt="search icon"/>} {...rest}/>);
};
const ShoppingCart = props => {
    const { clearShoppingCart, shoppingCartSize, ...rest } = props;
    const navigation = (0, native_1.useNavigation)();
    const onShoppingCartPress = () => {
        navigation.jumpTo(NewQuote_1.name);
    };
    return (<native_base_1.View {...rest} ml={{ base: 0, md: "auto" }} flexDirection="row" alignItems="center" mt={{
            base: 10,
            xl: 0,
        }}>
			<native_base_1.Pressable onPress={clearShoppingCart} mx="10">
				<native_base_1.Text variant="h4" textTransform="uppercase" lineHeight="18">
					{theme_1.Str.emptyCart.replace(" ", "\n")}
				</native_base_1.Text>
			</native_base_1.Pressable>
			<react_native_1.TouchableOpacity onPress={onShoppingCartPress}>
				<native_base_1.View style={{
            backgroundColor: "black",
            borderRadius: theme_1.Sizes.configRadius,
            padding: 10,
            marginTop: 1,
            marginEnd: 10,
        }}>
					<native_base_1.Image source={require("images/ic_shopping_cart.svg")} w={{
            base: 21,
            md: 35,
        }} h={{
            base: 21,
            md: 35,
        }} alt="shopping cart"/>
				</native_base_1.View>
				<native_base_1.Text style={{
            position: "absolute",
            minWidth: 25,
            height: 25,
            end: 0,
            top: 0,
            padding: 2,
            color: "white",
            backgroundColor: theme_1.Colors.colorVividRed1,
            borderRadius: 20,
            textAlign: "center",
            textAlignVertical: "center",
        }} variant="h5">
					{shoppingCartSize || "0"}
				</native_base_1.Text>
			</react_native_1.TouchableOpacity>
		</native_base_1.View>);
};
const Product = props => {
    const authContext = React.useContext(context_1.AuthContext);
    const { product, addProduct, removeProduct } = props;
    const [productSize, setProductSize] = React.useState(product?.carrito || "");
    const hangleProductSizeChange = React.useCallback((event) => {
        const newProductSize = event.target.value;
        if (Number(newProductSize) == 0) {
            removeProduct(product);
        }
        else if (Number(newProductSize) > 0 && newProductSize != productSize)
            addProduct(product, newProductSize ?? 0);
        //validamos si es un numero
        if (!isNaN(Number(newProductSize)))
            setProductSize(newProductSize);
    }, [productSize, product?.id]);
    const getStockTxt = () => {
        if ((Number(product?.stock ?? "0") ?? 0) > 0)
            return "Con stock";
        else
            return "Sin stock";
    };
    return (<native_base_1.HStack bg="white" borderRadius={theme_1.Sizes.configRadius} m="8" p={{ base: 15, md: 22 }} flex="1" flexGrow={1} flexShrink={1}>
			<native_base_1.VStack flex="1" justifyContent="space-between">
				<native_base_1.VStack style={{
            flex: 1,
        }}>
					<native_base_1.Text variant="h23">{product?.nombre || ""}</native_base_1.Text>
					<native_base_1.Text mt={{ base: 0, md: 2 }} variant="body5">
						{`SKU ${product.codigo || ""}`}
					</native_base_1.Text>
				</native_base_1.VStack>
				<native_base_1.VStack>
					<native_base_1.Text variant="h23">{product.preciodescuento}</native_base_1.Text>
					{product?.precio && (<native_base_1.Text mt={{ base: 0, md: 2 }} variant="body4" strikeThrough>
							{product?.precio}
						</native_base_1.Text>)}
					{product?.descuentofinal && <native_base_1.Text variant="body5">{`DESC: ${product?.descuentofinal || ""}`}</native_base_1.Text>}
				</native_base_1.VStack>
			</native_base_1.VStack>
			<native_base_1.VStack mt={{ base: 10, lg: 0 }} alignItems={{ base: "flex-end" }} justifyContent="space-between">
				<native_base_1.Text style={{
            backgroundColor: theme_1.Colors.colorVeryLightGray1,
            color: (Number(product?.stock ?? "0") ?? 0) > 0 ? theme_1.Colors.colorLimeGreen1 : theme_1.Colors.colorVividRed1,
            borderRadius: theme_1.Sizes.configRadius,
            paddingHorizontal: 13,
            paddingVertical: 3,
        }} variant="body6">
					{getStockTxt()}
				</native_base_1.Text>

				<native_base_1.HStack mt="12" alignItems="center">
					{/*
        <IconButton
            onPress={handleProductSizeMinus}
            icon={<Image source={icons.icMinus} w="10" h="10" />}
            borderWidth={2}
            borderColor="colorTextPrimary"
            borderRadius={5}
            p="10"
        />
        <Text px="14">{productSize}</Text>
        <IconButton
            onPress={handleProductSizePlus}
            icon={<Image source={icons.icPlus} w="10" h="10" />}
            borderWidth={2}
            borderColor="colorTextPrimary"
            borderRadius={5}
            p="10"
        />
        */}

					<native_base_1.Input value={productSize} placeholder="0" onChange={hangleProductSizeChange} style={{
            borderRadius: theme_1.Sizes.configRadiusSm,
            borderWidth: 2,
            borderColor: "black",
            fontFamily: theme_1.Fonts.bold,
            textAlign: "center",
        }} type="number" w={{
            base: 50,
            md: 60,
        }} fontSize="md" py={{ sm: 2, md: 8 }} px={{ sm: 2, md: 3 }} size={{ base: "xs", md: "md" }} mx={{ base: 10, lg: 40 }}/>
				</native_base_1.HStack>
			</native_base_1.VStack>
		</native_base_1.HStack>);
};
exports.default = AddProducts;
